import React from 'react';
import {useStyles} from "../ShopOrder.style";
import clsx from "clsx";
import ShopOrderRowProperties from "./ShopOrderRowProperties";
import Checkbox from '../../../ui_components/Checkbox/Checkbox';
import ShowOrderNumber from '../../../shared_components/Info/ShowOrderNumber/ShowOrderNumber';
import ShowDate from '../../../shared_components/Info/ShowDate/ShowDate';
import ShowText from '../../../shared_components/Info/ShowText/ShowText';
import ShowOrderStatus from '../../../shared_components/Info/ShowOrderStatus/ShowOrderStatus';
import ProductOrderStatus from '../../../entities/productOrder/ProductOrderStatus';
import UpdateDeliveryOrderStatusButton from '../../../shared_components/Buttons/UpdateDeliveryOrderStatusButton/UpdateDeliveryOrderStatusButton';
import ProductOrderTimelineButton from '../../../shared_components/Buttons/ProductOrderTimelineButton/ProductOrderTimelineButton';
import { motion } from 'framer-motion';
import AllowAccess from '../../../shared_components/Access/AllowAccess/AllowAccess';
import CommentsButton from '../../../shared_components/Buttons/CommentsButton/CommentsButton';
import ButtonSize from '../../../ui_components/Button/ButtonSize';
import ButtonType from '../../../ui_components/Button/ButtonType';
import RemoveShopOrderButton from '../../../shared_components/Buttons/RemoveShopOrderButton/RemoveShopOrderButton';


const ShopOrderRowSmall: React.FC<ShopOrderRowProperties> = ({
                                                                                    shopOrder,
                                                                                    onShopOrderSelect,
                                                                                    onUpdate
                                                                                }) => {

    const classes = useStyles();

    const onInternalShopOrderSelect = () => {
        onShopOrderSelect(shopOrder.id);
    }

    return (
        <div className={clsx(classes.shop_info_container_small)}>
            <div className={classes.first_row_small}>
                <div>
                    <div className={classes.order_number_container}>
                        <Checkbox text={''} onChange={onInternalShopOrderSelect}/>
                        <ShowOrderNumber orderNumber={shopOrder.orderNumber}/>
                    </div>
                    <ShowDate label={'Fecha'} timestamp={shopOrder.createdAt} className={classes.margin_top_4}/>
                </div>
            </div>
            <div className={classes.second_row_small}>
                <div>
                    <ShowText text={shopOrder.agencyName} title={'Agencia'}/>
                    <ShowText text={shopOrder.userName} title={'Vendedor'} className={classes.margin_top_8}/>
                </div>
                <div className={classes.status_container}>
                    <ShowOrderStatus status={shopOrder.status}/>
                    {shopOrder.status !== ProductOrderStatus.DELIVERED &&
                        shopOrder.status !== ProductOrderStatus.CANCELED &&
                        <UpdateDeliveryOrderStatusButton onSave={onUpdate} productOrderId={shopOrder.id}/>}
                    {shopOrder.status === ProductOrderStatus.DELIVERED &&
                        <ProductOrderTimelineButton
                            detailsLink
                            productOrderId={shopOrder.id}
                        />}
                </div>
            </div>
            <div className={classes.menu_container_small}>
                <motion.div animate={{scale: [0, 1]}} transition={{delay: 0.2, duration: 0.2}}>
                    <ProductOrderTimelineButton
                        size={ButtonSize.SMALL}
                        productOrderId={shopOrder.id}
                        showText
                        type={ButtonType.SECONDARY}
                    />
                </motion.div>
            </div>
            <div className={clsx(classes.menu_container_small,classes.margin_top_n10px)}>
                {/* <motion.div animate={{scale: [0, 1]}} transition={{delay: 0.2, duration: 0.2}}>
                    <ObservationsButton
                        size={ButtonSize.SMALL}
                        deliveryOrderId={shopOrder.id}
                        deliveryOrderNumber={shopOrder.orderNumber}
                        deliveryOrderObservations={shopOrder.observations}
                        showText
                        type={ButtonType.SECONDARY}
                    />
                </motion.div> */}
                <AllowAccess isRootAgency={true}>
                    <motion.div animate={{scale: [0, 1]}} transition={{delay: 0.2, duration: 0.2}}>
                        <CommentsButton
                            size={ButtonSize.SMALL}
                            deliveryOrderId={shopOrder.id}
                            deliveryOrderNumber={shopOrder.orderNumber}
                            showText
                            type={ButtonType.SECONDARY}
                        />
                    </motion.div>
                </AllowAccess>
            </div>
            <div className={clsx(classes.menu_container_small,classes.margin_top_n10px)}>
                <motion.div animate={{scale: [0, 1]}} transition={{delay: 0.2, duration: 0.2}}>
                    <RemoveShopOrderButton
                        size={ButtonSize.SMALL}
                        onSave={onUpdate}
                        shopOrderId={shopOrder.id}
                        showText
                        type={ButtonType.SECONDARY}
                    />
                </motion.div>
            </div>
        </div>
    )
}

export default ShopOrderRowSmall;
